module.exports = __webpack_public_path__ + "img/tips_btn.8fe67240.png";